<template>
  <div>
    <div v-if="!title">
      <p class="title is-4 mb-0">
        <b-icon icon="account" />
        {{name_f}} {{name_l}}
      </p>
      <p class="heading">{{email}}</p>
      <hr>
    </div>

    <div v-else class="has-text-centered">
      <p class="title is-5 mb-0">
        {{title}}
      </p>
      <p v-if="subTitle" class="heading">{{subTitle}}</p>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box">
          <b-field label="First">
            <b-input expanded icon="account" v-model="name_f" placeholder="First" />
          </b-field>

          <b-field label="Last">
            <b-input expanded icon="account-multiple" v-model="name_l" placeholder="Last" />
          </b-field>

          <b-field label="Email">
            <b-input icon="at" type="email" v-model="email" placeholder="you@example.com" />
          </b-field>

          <b-field label="Phone"
                   message="If outside the US or CA, add + sign & country code to your phone #, ex: +521234567891">
            <b-input icon="phone" type="tel" v-model="phone" placeholder="1234567891" />
          </b-field>

          <b-field v-if="!isModulesOnly" label="Text Alerts" message="Get text messages when picks are posted.">
            <b-radio-button v-model="text_alerts" :native-value="1" type="is-success">
              <b-icon icon="check" />
              <span>Yes</span>
            </b-radio-button>
            <b-radio-button v-model="text_alerts" :native-value="0" type="is-danger">
              <b-icon icon="close" />
              <span>No</span>
            </b-radio-button>
          </b-field>
        </div>
      </div>
      <div v-if="showPass" class="column">
        <div class="box">
          <b-field label="New Password">
            <b-input v-model="newPassword" type="password" icon="lock"></b-input>
          </b-field>
          <b-field label="Confirm Password" :type="!passwordsMatch ? 'is-danger' : ''">
            <b-input v-model="confirmedPassword" type="password" icon="lock"></b-input>
          </b-field>
          <div class="field has-text-right">
            <button @click="updatePassword" :disabled="!canSubmit" class="button is-success">Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'underscore/modules/debounce';
import { updateProfile } from '@/utils/api';

export default {
  props: {
    showPass: {
      type: Boolean,
      default: true
    },
    title: String,
    subTitle: String
  },
  data() {
    return {
      loading: false,
      user: null,
      name_f: undefined,
      name_l: undefined,
      email: undefined,
      country: undefined,
      zip: undefined,
      phone: undefined,
      street: undefined,
      street2: undefined,
      text_alerts: undefined,
      newPassword: undefined,
      confirmedPassword: undefined,
      isModulesOnly: process.env.VUE_APP_IS_MODULES_ONLY
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));

    ['name_f', 'name_l', 'email', 'country', 'zip', 'phone', 'street', 'street2']
    .forEach(datum => this[datum] = this.user[datum]);

    this.text_alerts = parseInt(this.user.text_alerts);
  },
  methods: {
    updatePassword: function () {
      this.loading = true;
      updateProfile({edits: {password: this.newPassword}})
      .then(async res => {
        if (!res.ok) {
          return this.$buefy.toast.open({
            message: 'Could not update password',
            type: 'is-danger'
          });
        }

        let resData = await res.json();

        if ('user' in resData) {
          localStorage.setItem('user', JSON.stringify(resData.user));
          this.$emit('userUpdated', resData.user);
        }

        return this.$buefy.toast.open({
          message: 'Password Updated',
          type: 'is-success'
        })
      })
      .catch(err => this.$buefy.toast.open({message: err.message, type: 'is-danger'}))
      .finally(() => this.loading = false);
    },
    updateUser: debounce(function (edits) {
      this.loading = true;

      updateProfile({edits})
      .then(async res => {
        if (!res.ok) {
          return this.$buefy.toast.open({
            message: 'Could not update password',
            type: 'is-danger'
          });
        }

        let resData = await res.json();

        if ('user' in resData) {
          localStorage.setItem('user', JSON.stringify(resData.user));
          this.$emit('userUpdated', resData.user);
        }

        return this.$buefy.toast.open({
          message: 'Profile Updated',
          type: 'is-success'
        })
      })
      .catch(err => this.$buefy.toast.open({message: err.message, type: 'is-danger'}))
      .finally(() => this.loading = false);
    }, 400)
  },
  computed: {
    passwordsMatch: function () {
      if (!this.newPassword) {
        return true;
      }
      return this.newPassword && this.newPassword === this.confirmedPassword;
    },
    canSubmit: function (){
      return this.newPassword && this.passwordsMatch;
    }
  },
  watch: {
    name_f: function (newNameF, oldNameF) {
      if (oldNameF === undefined) return;

      this.updateUser({name_f: newNameF});
    },
    name_l: function (newNameL, oldNameL) {
      if (oldNameL === undefined) return;

      this.updateUser({name_l: newNameL});
    },
    email: function (newEmail, oldEmail) {
      if (oldEmail === undefined) return;

      this.updateUser({email: newEmail});
    },
    zip: function (newZip, oldZip) {
      if (oldZip === undefined) return;

      this.updateUser({zip: newZip});
    },
    phone: function (newPhone, oldPhone) {
      if (oldPhone === undefined) return;

      this.updateUser({phone: newPhone});
    },
    text_alerts: function (newTextAlerts, oldTextAlerts) {
      if (oldTextAlerts === undefined) return;

      this.updateUser({text_alerts: newTextAlerts});
    },
    street: function (newStreet, oldStreet) {
      if (oldStreet === undefined) return;

      this.updateUser({street: newStreet});
    }
    ,
    street2: function (newStreet2, oldStreet2) {
      if (oldStreet2 === undefined) return;

      this.updateUser({street2: newStreet2});
    }
  }
}
</script>
